import { UserRoles } from '../../constants'
import { UserTypes } from '../../constants/UserRoles'

const userSelectors = {
    id: state => state.auth.user?.id,
    user: state => state.auth.user,
    isWaitingForGetCurrentUser: state => state.auth.isWaitingForGetCurrentUser,
    isSenseUser: state => state.auth.user?.email.endsWith('@sense.network'),
    isGatechUser: state => state.auth.user?.email.endsWith('@gatech.edu'),
    isAdmin: state => state.auth.user?.roles.includes(UserRoles.ADMIN),
    isShopUser: state => state.auth.user?.type === UserTypes.SHOP_USER,
    isLmsConfigurator: state => state.auth.user?.roles.includes(UserRoles.LMS_CONFIGURATOR),
    isBetaTester: state => state.auth.user?.roles.includes(UserRoles.BETA_TESTER),
    email: state => state.auth.user?.email,
    name: state => state.auth.user?.name,
    organizationId: state => state.auth.user?.organization_id,
    thresholds: state => ({
        low: state.auth.user?.low_threshold,
        medium: state.auth.user?.high_threshold,
        high: state.auth.user?.very_high_threshold,
    }),
    editingUserId: state => state.user.editingUserId,
    showInviteUserDrawer: state => state.user.showInviteUserDrawer,
}

export default userSelectors
